import { render, staticRenderFns } from "./PassportCznConfigEdit.vue?vue&type=template&id=4df10816&scoped=true"
import script from "./PassportCznConfigEdit.vue?vue&type=script&lang=js"
export * from "./PassportCznConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./PassportCznConfigEdit.vue?vue&type=style&index=0&id=4df10816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df10816",
  null
  
)

export default component.exports